var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6667 1.89154V5.33366C11.6667 5.80037 11.6667 6.03373 11.7575 6.21198C11.8374 6.36878 11.9648 6.49627 12.1217 6.57617C12.2999 6.66699 12.5333 6.66699 13 6.66699H16.4421M16.6667 8.32384V14.3337C16.6667 15.7338 16.6667 16.4338 16.3942 16.9687C16.1545 17.4391 15.7721 17.8215 15.3017 18.0612C14.7668 18.3337 14.0668 18.3337 12.6667 18.3337H7.33334C5.9332 18.3337 5.23314 18.3337 4.69836 18.0612C4.22795 17.8215 3.8455 17.4391 3.60582 16.9687C3.33334 16.4338 3.33334 15.7338 3.33334 14.3337V5.66699C3.33334 4.26686 3.33334 3.56679 3.60582 3.03202C3.8455 2.56161 4.22795 2.17916 4.69836 1.93948C5.23314 1.66699 5.9332 1.66699 7.33334 1.66699H10.0098C10.6213 1.66699 10.927 1.66699 11.2148 1.73607C11.4698 1.79731 11.7137 1.89832 11.9374 2.03539C12.1897 2.18999 12.4058 2.40618 12.8383 2.83857L15.4951 5.49542C15.9275 5.9278 16.1437 6.14399 16.2983 6.39628C16.4353 6.61996 16.5363 6.86383 16.5976 7.11891C16.6667 7.40663 16.6667 7.71237 16.6667 8.32384Z",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGrey);
export default __webpack_public_path__ + "static/media/fileGrey.d317a41bbf70d338df66e97572465b01.svg";
export { ForwardRef as ReactComponent };